import { ServiceConfig } from '../../../../shared/services/ServiceConfig'
import SignInRequest from '../../domain/entities/SignInRequest'
import SignInResponse from '../../domain/entities/SignInResponse'
import { IAuthRepository } from '../../domain/repositories/IAuthRepository'

const http = new ServiceConfig()

export default class AuthRepository implements IAuthRepository {
  public async signIn(params: SignInRequest): Promise<SignInResponse> {
    const response = await http.post('/auth', params)
    return response.data as SignInResponse
  }
}
